class HorizontalStepsList {
    constructor(rootElement) {
        this.rootElement = rootElement;
        this.steps = Array.from(this.rootElement.querySelectorAll('.horizontal-steps-list__step'));
        this.navButtons = Array.from(this.rootElement.querySelectorAll('.horizontal-steps-list__nav-list-item button'));

        this.init();
    }

    init() {
        this.showInitialStep();
        this.setInitialActiveNavLink();
        this.attachEventListeners();
    }

    showInitialStep() {
        if (this.steps.length) {
            this.steps[0].classList.remove('horizontal-steps-list__step--hidden');
        }
    }

    setInitialActiveNavLink() {
        if (this.navButtons.length) {
            this.navButtons[0].classList.add('horizontal-steps-list__button--active');
        }
    }

    attachEventListeners() {
        this.navButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.highlightNavLink(button);
                this.showStep(button);
            });
        });
    }

    highlightNavLink(activeButton) {
        this.navButtons.forEach(button => {
            button.classList.remove('horizontal-steps-list__button--active');
        });
        activeButton.classList.add('horizontal-steps-list__button--active');
        this.scrollNavIntoView(activeButton);
    }

    showStep(activeButton) {
        const targetId = activeButton.id.split('-')[1];

        this.steps.forEach(step => {
            const isTarget = step.id.split('-')[1] === targetId;
            const children = Array.from(step.children);

            setTimeout(() => {
                children.forEach(child => {
                    if (isTarget) {
                        child.classList.add('horizontal-steps-list__step--fade-in');
                        step.classList.remove('horizontal-steps-list__step--hidden');
                    } else {
                        child.classList.remove('horizontal-steps-list__step--fade-in');
                        step.classList.add('horizontal-steps-list__step--hidden');
                    }
                });
            }, 75);
        });
    }

    scrollNavIntoView(button) {
        const parent = button.parentNode;
        const scrollParent = parent.parentNode;

        const buttonRight = button.offsetLeft + button.offsetWidth + 50;
        const scrollVisibleRight = scrollParent.offsetLeft + scrollParent.offsetWidth;

        if (buttonRight >= scrollVisibleRight + scrollParent.scrollLeft) {
            const goal = buttonRight - scrollVisibleRight;
            scrollParent.scrollTo({ left: goal, behavior: 'smooth' });
        } else {
            const targetLeft = button.offsetLeft - scrollParent.offsetLeft - 50;
            scrollParent.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.horizontal-steps-list__wrap').forEach(el => {
        new HorizontalStepsList(el);
    });
});
